
<template>
  <div>
    <!-- <div class="mainTitle">代理等级</div> -->

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
            v-auth="'/agentLevel/addAgentLevel'"
            >新增</el-button
          >
          <!-- <el-button type="danger" @click="batchDeleteAgentLevel" icon="el-icon-minus">批量删除</el-button> -->
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
        v-loading="loading"
      >
        <!-- <el-table-column prop="grade" label="等级(1,2,3,...)"></el-table-column> -->
        <el-table-column
          align="center"
          prop="grade"
          label="序号"
          width="80"
        ></el-table-column>
        <el-table-column prop="name" label="代理类型"></el-table-column>
        <el-table-column prop="remark" label="类型备注"></el-table-column>
        <el-table-column
          align="center"
          width="150px"
          prop="enabled"
          label="状态"
        >
          <template slot-scope="row">
            <el-switch
              v-model="row.row.enabled"
              active-value="1"
              inactive-value="0"
              @change="updateSwitching(row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup" v-auth="'/agentLevel/updateAgentLevel'">
              <!-- <span @click="selection = scope.row.id, editFormVisible = true">编辑</span> -->
              <i
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click=";(selection = scope.row.id), (editFormVisible = true)"
              ></i>

              <!-- <span @click="deleteAgentLevel(scope.row)">删除</span> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="新增类型"
      :visible.sync="addFormVisible"
      width="400px"
      left
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="层级名称" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入层级名称"
              auto-complete="off"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="层级排序" prop="grade">
            <el-input
              type="number"
              v-model="addForm.grade"
              placeholder="请输入等级"
              auto-complete="off"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="层级备注">
            <el-input
              type="textarea"
              v-model="addForm.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="是否启用" prop="enabled">
            <!-- <el-input type="number" v-model="addForm.enabled" placeholder="请输入是否启用 1启用" auto-complete="off" maxlength="10"></el-input> -->
            <el-radio v-model="addForm.enabled" label="1">启用</el-radio>
            <el-radio v-model="addForm.enabled" label="0">禁用</el-radio>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentLevel">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑类型"
      :visible.sync="editFormVisible"
      width="400px"
      left
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="层级名称" prop="name">
            <el-input
              v-model="editForm.name"
              placeholder="请输入层级名称"
              auto-complete="off"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="层级排序" prop="grade">
            <el-input
              type="number"
              v-model="editForm.grade"
              placeholder="请输入等级"
              auto-complete="off"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="层级备注">
            <el-input
              type="textarea"
              v-model="editForm.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="是否启用" prop="enabled">
            <!-- <el-input type="number" v-model="addForm.enabled" placeholder="请输入是否启用 1启用" auto-complete="off" maxlength="10"></el-input> -->
            <el-radio v-model="editForm.enabled" label="1">启用</el-radio>
            <el-radio v-model="editForm.enabled" label="0">禁用</el-radio>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateAgentLevel">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      searchForm: {},
      addForm: {
        grade: "",
        name: "",
        enabled: "1"
      },
      addFormRules: {
        grade: [
          {
            required: true,
            message: "请输入等级(1,2,3,...)",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "等级(1,2,3,...)格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入层级名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "级别名称长度在1到50个字"
          }
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "change"
        }
      },
      editForm: {
        name: "",
        grade: "",
        enabled: "1"
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入层级名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "层级名称长度在1到50个字"
          }
        ],
        grade: [
          {
            required: true,
            message: "请输入等级(1,2,3,...)",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "等级(1,2,3,...)格式不正确"
          }
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "change"
        }
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/agentLevel/upload`,
      fileList: [],
      loading: true
    };
  },
  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getAgentLevel () {
      this.api.agentLevel
        .getAgentLevel({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
          this.editForm.enabled = String(this.editForm.enabled);
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateSwitching (row) {
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled
      };
      this.api.agentLevel.updateAgentLevel(obj).then(result => {
        if (result.success) {
          this.pageList();
        } else {
          this.pageList();
          this.$message.error(result.message);
        }
      });
    },
    pageList () {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.agentLevel
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          for (let i in this.page.rows) {
            this.page.rows[i].enabled = String(this.page.rows[i].enabled);
          }

          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAgentLevel () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.agentLevel
            .addAgentLevel(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateAgentLevel () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.agentLevel
            .updateAgentLevel(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentLevel (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentLevel
            .deleteAgentLevel([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteAgentLevel () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentLevel
            .deleteAgentLevel(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      if (!response.success) {
        return this.$message.error(response.message);
      }
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.agentLevel
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData () {
      this.api.agentLevel
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData () {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getAgentLevel();
      }
    }
  },
  mounted () {
    this.pageList();
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/agentLevel/index.vue